var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1641 27.9688H9.83594L7.49219 35H0.015625L12.7188 0.875H19.2344L32.0078 35H24.5312L22.1641 27.9688ZM11.7344 22.2734H20.2656L15.9766 9.5L11.7344 22.2734Z",
    fill: "url(#paint0_linear_6_24)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_24",
    x1: 16.0117,
    y1: 0.875,
    x2: 16.0117,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD5F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.3f93757d557822918227121fd9cb6c8e.svg";
export { ForwardRef as ReactComponent };